import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { AngularFireModule} from '@angular/fire';
import { environment } from '../environments/environment';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireMessagingModule } from '@angular/fire/messaging';
import { MessagingService } from './shared/messaging.service';
import { AsyncPipe } from '../../node_modules/@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from './material/material.module';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpModule } from '@angular/http';
import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction'
import { AppRoutingModule } from './app-routing.module';
import { DatePipe,DecimalPipe } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

//services
import { UsersService } from "./services/users/users.service";
import { FleetService } from './services/fleet/fleet.service';
import { ResourceService } from './services/resource/resource.service';
import { RoleService } from './services/role/role.service';
import { TransporterService } from './services/transporter/transporter.service';
import { TripService } from './services/trip/trip.service';
import { SearchService } from './services/search/search.service';
import { RateService } from './services/rate/rate.service';

//messageservice
import { MessagesService } from './services/messages/messages.service';
import { UploadfileService } from './services/uploadfile/uploadfile.service';

//components
import { LoginComponent } from './login/login.component';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { RegisterComponent } from './register/register.component';

import { ManageFleetComponent } from './pages/managefleet/managefleet.component';
import { PagesComponent } from './pages/pages.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { AddfleetComponent } from './pages/managefleet/addfleet/addfleet.component';
import { AllfleetComponent } from './pages/managefleet/allfleet/allfleet.component';
import { EditfleetComponent } from './pages/managefleet/editfleet/editfleet.component';
import { TransporterComponent } from './pages/transporter/transporter.component';
import { AddtransporterComponent } from './pages/transporter/addtransporter/addtransporter.component';
import { AlltransporterComponent } from './pages/transporter/alltransporter/alltransporter.component';
import { EdittransporterComponent } from './pages/transporter/edittransporter/edittransporter.component';
import { UserandroleComponent } from './pages/userandrole/userandrole.component';
import { AlluserroleComponent } from './pages/userandrole/alluserrole/alluserrole.component';
import { AdduserComponent } from './pages/userandrole/adduser/adduser.component';
import { EdituserComponent } from './pages/userandrole/edituser/edituser.component';
import { UserrolemanageComponent } from './pages/userandrole/userrolemanage/userrolemanage.component';
import { OrderComponent } from './pages/order/order.component';
import { AllorderdetailsComponent } from './pages/order/allorderdetails/allorderdetails.component';
import { SchedulingandplanningComponent } from './pages/schedulingandplanning/schedulingandplanning.component';
import { CreatetriptableComponent } from './pages/schedulingandplanning/createtriptable/createtriptable.component';
import { EdittriptableComponent } from './pages/schedulingandplanning/edittriptable/edittriptable.component';
import { ScheduletriptableComponent } from './pages/schedulingandplanning/scheduletriptable/scheduletriptable.component';
import { EdittripmodalComponent } from './pages/schedulingandplanning/edittripmodal/edittripmodal.component';
import { ScheduletripmodalComponent } from './pages/schedulingandplanning/scheduletripmodal/scheduletripmodal.component';
import { FleetdetailsComponent } from './pages/fleet/fleetdetails/fleetdetails.component';
import { FleetComponent } from './pages/fleet/fleet.component';
import { TripComponent } from './pages/trip/trip.component';
import { TripdetailsComponent } from './pages/trip/tripdetails/tripdetails.component';
import { TripmapviewComponent } from './pages/trip/tripmapview/tripmapview.component';
import { OrdermapviewComponent } from './pages/order/ordermapview/ordermapview.component';
import { FleetmapviewComponent } from './pages/fleet/fleetmapview/fleetmapview.component';
import { OrderlistviewComponent } from './pages/order/orderlistview/orderlistview.component';
import { FleetlistviewComponent } from './pages/fleet/fleetlistview/fleetlistview.component';
import { TriplistviewComponent } from './pages/trip/triplistview/triplistview.component';
import { HomeComponent } from './pages/home/home.component';
import { SchedulefleetComponent } from './pages/managefleet/schedulefleet/schedulefleet.component';
import { DialogConfirm } from './pages/schedulingandplanning/edittripmodal/edittripmodal.component';
import { DeleteDialogConfirm } from './pages/schedulingandplanning/edittripmodal/edittripmodal.component';
import { DeleteOrderConfirm } from './pages/admin/admin.component';
import {ChangeStatusDialogConfirm} from './pages/admin/admin.component';
import { ImagePopup } from './pages/order/allorderdetails/allorderdetails.component';
import { ErrorExcelUpload } from './pages/schedulingandplanning/schedulingandplanning.component';
import { ManagecustomerComponent } from './pages/managecustomer/managecustomer.component';
import { AddcustomerComponent } from './pages/managecustomer/addcustomer/addcustomer.component';
import { AllcustomersComponent } from './pages/managecustomer/allcustomers/allcustomers.component';
import { EditcustomerComponent } from './pages/managecustomer/editcustomer/editcustomer.component';

import { Interceptor } from "./auth/interceptor";
import { TokenStorage } from "./auth/token.storage";
import { AuthGuard} from './auth/auth.guard';
import { AuthService } from './auth/auth-guard.service';
import { StoreUserDetails } from './auth/storeuserdetails';
import { AdminComponent } from './pages/admin/admin.component';

//Daterange picker module https://gnurub.github.io/ngx-daterangepicker/
import { NgxDateRangePickerModule } from '../ngx-daterangepicker';
import { OrderDetailsAndEditOrderComponent } from './pages/schedulingandplanning/orderdetailsandeditorder/orderdetailsandeditorder.component';
import { SearchresultComponent } from './pages/searchresult/searchresult.component';
import { TripanalyticsComponent } from './pages/tripanalytics/tripanalytics.component';
import { OrderreportComponent } from './pages/orderreport/orderreport.component';
import { NotificationService } from './services/notification/notification.service';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SnreportComponent } from './pages/snreport/snreport.component';
import { AddpickupComponent } from './pages/addpickup/addpickup.component';
import { TripdetailreportComponent } from './pages/tripdetailreport/tripdetailreport.component';
import { PickupsComponent } from './pages/pickups/pickups.component';
import { TransportrateComponent } from './pages/transportrate/transportrate.component';
import { MapComponent } from './pages/tripdetailreport/mapcomponent/map.component';
import { AngularGanttScheduleTimelineCalendarModule } from "angular-gantt-schedule-timeline-calendar";
import { TimelineComponent } from './pages/timeline/timeline.component';
import { UserreportComponent } from './pages/userreport/userreport.component';
import { CdkDetailRowDirective } from './pages/userreport/cdk-detail.row';
import { SummaryReportComponent } from './pages/summary-report/summary-report.component';
import { RunnerboyreportComponent } from './pages/runnerboyreport/runnerboyreport.component';
import { MarketingboyreportComponent } from './pages/marketingboyreport/marketingboyreport.component';
import { HomecollectionboyreportComponent } from './pages/homecollectionboyreport/homecollectionboyreport.component';
import { DiagnosticSummaryReportComponent } from './pages/diagnostic-summary-report/diagnostic-summary-report.component';
import { OndutyoffdutyreportComponent } from './pages/ondutyoffdutyreport/ondutyoffdutyreport.component'
import { NgxSpinnerModule } from 'ngx-spinner';
import { OrderdailyreportComponent } from './pages/orderdailyreport/orderdailyreport.component';
import { ManageAuditTrailComponent } from './pages/manage-audit-trail/manage-audit-trail.component';
import { AuditTrailService } from './services/audit/audit-trail.service';
import { OrdertrackingComponent } from './pages/order/ordertracking/ordertracking.component'

const customNotifierOptions: NotifierOptions = {
  position: {
		horizontal: {
			position: 'right',
			distance: 12
		},
		vertical: {
			position: 'bottom',
			distance: 12,
			gap: 10
		}
	},
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    NavbarComponent,
    LoginComponent,
    SidebarComponent,
    RegisterComponent,
    ManageFleetComponent,
    FleetComponent,
    PagesComponent,
    ForgotpasswordComponent,
    AddfleetComponent,
    AllfleetComponent,
    EditfleetComponent,
    TransporterComponent,
    AddtransporterComponent,
    AlltransporterComponent,
    EdittransporterComponent,
    UserandroleComponent,
    AlluserroleComponent,
    AdduserComponent,
    EdituserComponent,
    UserrolemanageComponent,
    OrderComponent,
    AllorderdetailsComponent,
    SchedulingandplanningComponent,
    OrderDetailsAndEditOrderComponent,
    CreatetriptableComponent,
    EdittriptableComponent,
    ScheduletriptableComponent,
    EdittripmodalComponent,
    ScheduletripmodalComponent,
    FleetdetailsComponent,
    TripComponent,
    TripdetailsComponent,
    TripmapviewComponent,
    OrdermapviewComponent,
    FleetmapviewComponent,
    OrderlistviewComponent,
    FleetlistviewComponent,
    TriplistviewComponent,
    HomeComponent,
    SchedulefleetComponent,
    DialogConfirm,
    DeleteOrderConfirm,
    DeleteDialogConfirm,
    ErrorExcelUpload,
    ChangeStatusDialogConfirm,
    SearchresultComponent,
    ImagePopup,
    AdminComponent,
    TripanalyticsComponent,
    OrderreportComponent,
    SnreportComponent,
    AddpickupComponent,
    ManagecustomerComponent,
    AddcustomerComponent,
    AllcustomersComponent,
    EditcustomerComponent,
    TripdetailreportComponent,
    PickupsComponent,
    TransportrateComponent,
    MapComponent,
    TimelineComponent,
    UserreportComponent,
    CdkDetailRowDirective,
    SummaryReportComponent,
    RunnerboyreportComponent,
    MarketingboyreportComponent,
    HomecollectionboyreportComponent,
    DiagnosticSummaryReportComponent,
    OndutyoffdutyreportComponent,
    OrderdailyreportComponent,
    ManageAuditTrailComponent,
    OrdertrackingComponent
  ],
  imports: [
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features,
    AngularFireStorageModule,
    AngularFireMessagingModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    HttpClientModule,
    NgxDateRangePickerModule,
    AgmCoreModule.forRoot({
      apiKey: environment.mapKey
    }),
    AgmDirectionModule,
    NgbModule.forRoot(),
    NotifierModule.withConfig(customNotifierOptions),
    SelectDropDownModule,
    NgxPermissionsModule.forRoot(),
    NgxPermissionsModule.forChild({
      permissionsIsolate: true, 
      rolesIsolate: true
    }),
    AngularGanttScheduleTimelineCalendarModule,
    NgxSpinnerModule
  ],
  providers: [
    UsersService,
    FleetService,
    ResourceService,
    TransporterService,
    RoleService,
    TripService,
    SearchService,
    DatePipe,
    DecimalPipe,
    TokenStorage,
    AuthGuard,
    AuthService,
    StoreUserDetails,
    UploadfileService,
    RateService,
    MessagesService, {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true
    },
    MessagingService, 
    AsyncPipe,
    NotificationService,
    AuditTrailService
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    EdituserComponent,
    AllorderdetailsComponent,
    EdittripmodalComponent,
    ScheduletripmodalComponent,
    OrderDetailsAndEditOrderComponent,
    FleetdetailsComponent,
    TripdetailsComponent,
    DialogConfirm,
    DeleteDialogConfirm,
    ChangeStatusDialogConfirm,
    DeleteOrderConfirm,
    ErrorExcelUpload,
    ForgotpasswordComponent, 
    EditfleetComponent, 
    EdittransporterComponent, 
    ImagePopup,
    TripanalyticsComponent,
    AddpickupComponent,
    EditcustomerComponent,
    TransportrateComponent,
    MapComponent
  ]
})
export class AppModule { }